export default __webpack_public_path__ + "static/media/credit-cards.d5c5c727.png";